import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { EventResponseEvent } from '../../types/event-response.type';

@Component({
  selector: 'app-event-carousel-flat',
  templateUrl: './event-carousel-flat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCarouselFlatComponent {
  @Input()
  public itemsPerSlide = 4;

  @Input()
  public events: EventResponseEvent[];

  @Input()
  public isMobile: boolean = false;

  @Output() eventClicked = new EventEmitter();
}
